/**
 * Builds a 2D array (header + data rows) suitable for CSV serialization.
 *
 * This is the single source of truth for column resolution and record-to-row
 * mapping. Environment-specific wrappers in `@common-web/lib/createCsv` (browser)
 * and `@api/lib/csvUtils` (Node/Bun) call this and pass the result through
 * their respective `csv-stringify` entry point.
 *
 * If you need to extend CSV generation logic (custom formatters, column
 * transforms, etc.), add it here rather than in the environment wrappers.
 * The wrappers should remain thin — import path + `stringify` call only.
 *
 * TODO: Neutralize formula-leading cell values (`=`, `+`, `-`, `@`) across all exports without
 * breaking negative numbers or round-tripped import templates: https://app.asana.com/1/1206214889537900/project/1206881612175705/task/1218953780627696?focus=true
 */
export function buildCsvRows(
  records: Record<string, unknown>[],
  columns?: string[],
): string[][] {
  if (records.length === 0) return [];
  const cols = columns ?? Object.keys(records[0]);
  const rows = records.map((record) => cols.map((col) => String(record[col] ?? '')));
  return [cols, ...rows];
}
